import React from "react";

const RadioButton = ({ name, value, label, onClick, defaultChecked }) => {
  return (
    <label className="brief-radio-label">
      <input
        className="brief-radio-button-text"
        type="radio"
        name={name}
        value={value}
        defaultChecked={defaultChecked}
        onClick={onClick}
      />
      {label}
    </label>
  );
};

export default RadioButton;